import React from 'react';
import ImpersonateStudent from 'components/staffer/ImpersonateStudent';
import { ImpersonateStudentProps } from 'components/staffer/ImpersonateStudent/types';
import styles from './index.module.scss';

const ImpersonateShortcut = ({
  buttonClass,
  student,
  enabled,
  programId,
  stafferId,
  impersonatePath,
  useNewIcon = false,
}: ImpersonateStudentProps) => (
  <ImpersonateStudent
    buttonClass={buttonClass}
    enabled={enabled}
    iconClass={styles.shareIcon}
    impersonatePath={impersonatePath}
    programId={programId}
    stafferId={stafferId}
    student={student}
    tooltipPosition="bottom"
    useNewIcon={useNewIcon}
    wrapperClass=""
  />
);

export default ImpersonateShortcut;
